"use strict";

exports.__esModule = true;
exports.getValueByString = getValueByString;
/**
 * Given a key using key.key.indexor[0].key extract the value from the object
 */
function getValueByString(o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}